import type { ChronumSnapshotMeta } from '@shared/api';
import { SkeletonLine } from '@shared/ui/Skeleton';
import {
  CHRONUM_FEEDS,
  formatDateTime,
  originLabel,
  snapshotStatusHint,
  snapshotStatusLabel,
  snapshotStatusTone,
  typo,
  type ChronumFeed,
} from '@entities/chronum';
import { Dot } from '../ui';
import { Feed, Feeds } from './styles';

export function FeedCell({
  feed,
  snapshot,
}: {
  feed: ChronumFeed;
  snapshot: ChronumSnapshotMeta | null | undefined;
}) {
  if (!snapshot) {
    return (
      <Feed $tone="muted">
        <span className="label">{feed.label}</span>
        <span className="state">
          <Dot $tone="muted" aria-hidden="true" />
          {snapshot === undefined ? 'Узнаю…' : 'Ещё не загружалось'}
        </span>
      </Feed>
    );
  }
  const tone = snapshotStatusTone(snapshot.status);
  const reason = snapshot.status === 'error' ? snapshotStatusHint('error', snapshot.message) : null;
  return (
    <Feed $tone={tone}>
      <span className="label">{feed.label}</span>
      <span className="state">
        <Dot $tone={tone} aria-hidden="true" />
        {snapshotStatusLabel(snapshot.status)}
      </span>
      <span className="meta">{formatDateTime(snapshot.fetched_at)}</span>
      <span className="meta">{originLabel(snapshot)}</span>
      {reason && (
        <span className="meta reason" title={reason}>
          {reason}
        </span>
      )}
    </Feed>
  );
}

export function FeedsSkeleton() {
  return (
    <Feeds data-open="false" aria-busy="true" aria-label="Загрузка состояния данных Хронума">
      {CHRONUM_FEEDS.map((f) => (
        <Feed key={f.key} $tone="muted">
          <SkeletonLine $height={10} $width="60%" />
          <SkeletonLine $height={14} $width="80%" />
          <SkeletonLine $height={10} $width="70%" />
        </Feed>
      ))}
    </Feeds>
  );
}

export function FeedHint({ feed }: { feed: ChronumFeed }) {
  return (
    <>
      <dt>{feed.label}</dt>
      <dd>{typo(feed.hint)}</dd>
    </>
  );
}
